/**
 * Status metadata for Scheduled Group Unlock — single source of truth for
 * labels + Pill tones, mirroring the pattern in features/assets/assetMeta.js.
 */
export const SESSION_STATUS_META = {
  SCHEDULED: {label: "Scheduled", tone: "info"},
  PROCESSING: {label: "Processing", tone: "warning"},
  COMPLETED: {label: "Completed", tone: "success"},
  COMPLETED_WITH_FAILURES: {label: "Completed (partial)", tone: "warning"},
  FAILED: {label: "Failed", tone: "danger"},
  CANCELLED: {label: "Cancelled", tone: "neutral"},
};

export const EXECUTION_STATUS_META = {
  PENDING: {label: "Pending", tone: "neutral"},
  RETRYING: {label: "Retrying", tone: "warning"},
  SUCCESS: {label: "Success", tone: "success"},
  FAILED: {label: "Failed", tone: "danger"},
};

export function sessionStatusMeta(status) {
  return SESSION_STATUS_META[status] || {label: status || "—", tone: "neutral"};
}

export function executionStatusMeta(status) {
  return EXECUTION_STATUS_META[status] || {label: status || "—", tone: "neutral"};
}

/** Common IANA zones offered in the scheduling form, browser zone is always included. */
export const COMMON_TIMEZONES = [
  "Asia/Kolkata", "Asia/Dubai", "Asia/Singapore", "Asia/Karachi", "Asia/Dhaka",
  "Europe/London", "Europe/Berlin", "America/New_York", "America/Los_Angeles",
  "Africa/Nairobi", "Africa/Johannesburg", "Australia/Sydney", "UTC",
];

/** Extracts a human-readable error message from an axios error for this feature's
 * plain-string (non-JSON-enveloped) error responses. */
export function extractErrorMessage(err, fallback) {
  const data = err?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.responseMessage) return data.responseMessage;
  if (data?.message) return data.message;
  return fallback;
}
